import { IconButton } from "@mui/material"
import { getFeeAll, getFeeFilters, getFeeSort } from "../../api"
import ListData from "../common/ListData"
import routes from "../../constants/routes"
import FeePayApproveCard from "../cards/FeePayApproveCard"
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded"
import { Link } from "react-router-dom"

const FeePayments = () => {
  const CTA = () => (
    <Link to={routes.ACCOUNTING.HOME}>
      <IconButton>
        <ArrowBackRoundedIcon />
      </IconButton>
    </Link>
  )

  return (
    <>
      <ListData
        getFilters={getFeeFilters}
        getSort={getFeeSort}
        getAllData={getFeeAll}
        initialFilters={{
          filter: {
            approvalStatus: ["PENDING"],
          },
        }}
        HeaderRight={CTA}
        Card={FeePayApproveCard}
      />
    </>
  )
}

export default FeePayments
